import PropTypes from "prop-types";

/** Common Components */
import Avatar from "../ui/avatar/Avtar";
import Iconify from "../../layouts/components/iconify/iconify";
import { getProjectGradient } from "../../lib/getProjectGradient";

/** CSS Files */
import "./ProjectCard.scss";

const ProjectCard = ({ project, cardColumns, onNavigation }) => {
  return (
    <div
      className={`project-card-container ${
        cardColumns ? `col-${cardColumns}` : "col-3"
      }`}
    >
      <button
        className="project-card "
        onClick={() => onNavigation(project)}
      >
        <div className="card-part col-12">
          <div className="avatar-container">
          <Avatar
              src=""
              alt={project.projectName}
              fallbackText={project.projectCode || undefined}
              size="large"
              shape="circle"
              gradient={getProjectGradient(project.projectId)}
            />
            <div className="avatar-title">
              <h2 className="card-title">{project.projectName}</h2>
              <div className="project-code">Code : {project.projectCode}</div>
            </div>
           
          </div>
        </div>
        <div className="top-stutas-section">
          <div className="task-box">
            {" "}
            <Iconify icon="fluent:clipboard-task-list-20-regular" />
            <p>{project.totalTask}</p>
            <span>Total Tasks</span>
          </div>
          <div className="task-box">
            <Iconify icon="mynaui:users-group" />
            <p>{project.memberCount}</p>
            <span>Members</span>
          </div>
          <div className="task-box">
            <Iconify icon="solar:list-check-broken" />
            <p>{project.done}</p>
            <span>Done Tasks</span>
          </div>
        </div>
        <div className="card-content col-12">
          <div className="user-name">
            <Iconify icon="solar:user-broken" />
            &nbsp;&nbsp;
            <span>Responsible User </span>
            <p> &nbsp; &nbsp;{project.responsibleUser}</p>
          </div>
          <div className="card-info">
            <div className="card-info-details">
              <div className="not-started">
                <Iconify icon="stash:circle-dot" />
                <span>Not Started Tasks</span>
              </div>
              <p>{project.notStarted}</p>
            </div>
            <div className="card-info-details">
              <div  className="active">
                <Iconify icon="stash:circle-dot" />
                <span>Active Tasks</span>
              </div>
              <p>{project.active}</p>
            </div>
            <div className="card-info-details">
              <div className="testing">
                <Iconify icon="stash:circle-dot" />
                <span>Testing Tasks</span>
              </div>
              <p>{project.testing}</p>
            </div>
            <div className="card-info-details">
              <div className="close">
                <Iconify icon="stash:circle-dot" />
                <span>Closed Tasks</span>
              </div>
              <p>{project.closed}</p>
            </div>
          </div>
        </div>
      </button>
    </div>
  );
};

ProjectCard.propTypes = {
  project: PropTypes.object.isRequired,
  cardColumns: PropTypes.number,
  onNavigation: PropTypes.func,
};

export default ProjectCard;
